import React from 'react'
import Button from '@components/Button'
import useState from '@hooks/useState'
import FormatNumber from '@i18n/formatNumber/Component'

import Form from './Form'

import styles from './styles.module.css'

export default function Redeem(props) {
  const {name, multipleOf} = props.config
  const [redeeming, setRedeeming] = useState(false)
  const CURRENCY_UNIT = 1
  return (
    <div className={styles.container}>
      <h1>Es muy fácil canjear tus {name}</h1>
      <p>
        Cada uno de tus {name} es equivalente a <FormatNumber value={CURRENCY_UNIT} /> para comprar
        en nuestra plataforma. Cuando quieras usar tus {name}, los convertimos en un cupón para que
        uses en tu siguiente compra.{' '}
        {multipleOf ? (
          <FormatNumber
            value={multipleOf}
            render={number => <>{`El monto a canjear debe ser múltiplo de  ${number}`}</>}
          />
        ) : (
          ''
        )}
      </p>
      {redeeming ? (
        <Form {...props} setRedeeming={setRedeeming} />
      ) : (
        <Button primary onClick={() => setRedeeming(true)}>
          Canjear mis {name}
        </Button>
      )}
    </div>
  )
}
